import React from "react";
import styles from './about.module.css';
import './about.css'
import { langsList, toolsList, findMeList } from "../../imgs/logos";
function About(props) {
  return (
    <div id="About">
    <div id="About-div" data-aos="fade-up">
      <div className={styles.about}>

      <div className={styles.header}>About Me</div>
      <div className={styles.main}>
        <div>
          <p className="mt-3">
          I’m an incoming Master’s student in Computer Science at Toronto Metropolitan University, driven by a passion for creating new things, designing systems, and solving challenging problems.
          </p>
          <p className="mt-3">
          My academic and professional journey has taken me through various areas of computer science, including artificial intelligence, web development, robotics, and data science. I’m currently preparing to do research on artificial intelligence, particularly in reasoning and planning, during my master’s program.
          </p>
          <p className="mt-3">
          Outside of tech, I enjoy reading on various topics, watching films, painting, making sculptures, and playing the bass.
          </p>
          <p className="mt-3">
          Feel free to reach out via LinkedIn or Email if you'd like to collaborate on a project or just have a chat!
          </p>
        <div className={styles.findMeIcons}>
          {findMeList.map(imgs =>
            <div className={styles.skill}>
              <a href={imgs.link}><img src={imgs.src} alt={imgs.alt} id={imgs.id} /></a> <span>{imgs.alt}</span>
            </div>
          )
          }
        </div>
        </div>
      </div>
      <div id="skills">
        <br />
        <br />
        <div className={styles.skillsWrapper} data-aos="fade-up">
          <div className={styles.skillsHeader}> Skills</div>
          <div className={styles.langsHeader}>Languages</div>
          <div className={styles.images}>
            {langsList.map(imgs =>
              <div className={styles.skill}>
                <img src={imgs.src} alt={imgs.alt} id={imgs.id} />
                <span>{imgs.alt}</span>
              </div>
            )
            }
          </div>

          <div className={styles.toolsHeader}>Development Tools</div>
          <div className={styles.images}>
            {toolsList.map(imgs =>
              <div className={styles.skill}>
                <img src={imgs.src} alt={imgs.alt} id={imgs.id} />
                <span>{imgs.alt}</span>
              </div>
            )
            }
          </div>

        </div>
      </div>
    </div>
    </div>
    </div>
  );
}
export default About;